import { Component } from 'react';

export default class HorizontalBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listBars: [],
      data: this.props.data,
    };
  }

  componentDidMount() {
    this.setState((state) => ({
      ...state,
      listBars: this.getListBarWithOtherParameters(),
      data: this.props.data,
    }));
  }

  /**
   * Make the calculus of total width
   */
  calcWidthTotal() {
    let widthTotal = 0;
    this.props.data.forEach((bar) => {
      widthTotal = widthTotal + bar.value;
    });
    return widthTotal;
  }

  /**
   * Returns the same list of bars with position and barWidth
   */
  getListBarWithOtherParameters() {
    const widthTotal = this.calcWidthTotal();
    let position = 0;
    let barWidth = 0;
    return this.props.data.map((bar) => {
      position = position + barWidth;
      barWidth = (bar.value * 100) / widthTotal;
      bar = Object.assign({ position, barWidth, widthTotal }, bar);
      return bar;
    });
  }

  /**
   * Returns a list of texts of the bars into a div component
   */
  getListTextBar(showTextInsteadValue) {
    return this.state.listBars.map((bar, index) => {
      return (
        <div
          key={index}
          style={{
            position: 'relative',
            float: 'left',
            textAlign: 'center',
            width: `${bar.barWidth}%`,
            fontWeight: showTextInsteadValue && this.props.label === bar.name ? 'bold' : 'normal',
          }}>
          {showTextInsteadValue && bar.name}
          {!showTextInsteadValue && (bar.description || bar.value || '')}
        </div>
      );
    });
  }

  renderPointer() {
    const widthTotal = this.calcWidthTotal();
    const value = this.props.value > widthTotal ? widthTotal : this.props.value;
    let position = (value / widthTotal) * 100;
    position = position > 99 ? 99 : position;
    return (
      <svg
        style={{
          marginLeft: position ? `calc(${position}% - 7.5px)` : '0%',
          marginBottom: '1.5px',
        }}
        width="15"
        height="7.5">
        <path d="M0 0 L7.5 7.5 L15 0 Z" fill={this.props.pointerColor} />
      </svg>
    );
  }

  renderBars() {
    const listBars = [];

    listBars.push(
      this.state.listBars.map((bar, index) => {
        return (
          <g key={index} onClick={(e) => this.onClick(e, bar)}>
            <rect
              width={`${bar.barWidth + 0.1}%`}
              height={this.props.height}
              style={{
                fill: bar.color,
                strokeWidth: `${
                  (this.props.outlineWidth * 100) / (bar.widthTotal / this.props.data.length)
                }%`,
                stroke: this.props.outlineColor,
              }}
              x={`${bar.position}%`}
            />
            <title>{`${this.props.label}: ${this.props.value}`}</title>
          </g>
        );
      })
    );
    return listBars;
  }

  renderLabel(showTextInsteadValue) {
    return (
      <div
        id={`${this.props.id}_text`}
        style={{
          textAlign: 'left',
          display: 'flex',
          width: '100%',
          fontFamily: 'Open Sans',
          fontSize: '8px',
          lineHeight: '14px',
          color: this.props.fontColor,
        }}>
        {this.getListTextBar(showTextInsteadValue)}
      </div>
    );
  }

  render() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {(this.props.showTextUp || this.props.showValueUp) &&
          this.renderLabel(this.props.showTextUp)}
        {this.props.value !== null && this.renderPointer()}
        <svg
          style={{ borderRadius: this.props.borderRadius }}
          id={this.props.id}
          width="100%"
          height={this.props.height}>
          {this.renderBars()}
        </svg>
        {(this.props.showTextDown || this.props.showValueDown) &&
          this.renderLabel(this.props.showTextDown)}
      </div>
    );
  }
}

// eslint-disable-next-line sonarjs/no-commented-code
/* HorizontalBar.propTypes = {
  data: PropTypes.array.isRequired,
  id: PropTypes.string,
  height: PropTypes.number,
  showTextIn: PropTypes.bool,
  showTextUp: PropTypes.bool,
  showTextDown: PropTypes.bool,
  showValueUp: PropTypes.bool,
  showValueDown: PropTypes.bool,
  fontColor: PropTypes.string,
}; */

HorizontalBar.defaultProps = {
  height: 16,
  showTextIn: false,
  showTextUp: false,
  showTextDown: true,
  showValueUp: true,
  showValueDown: false,
  fontColor: '#262626',
  pointerColor: '#262626',
  borderRadius: '8px',
  id: 'hsbar',
  value: null,
  data: [
    {
      name: 'Healthy',
      value: 5,
      description: '0',
      color: '#5B8C00',
    },
    {
      name: 'Mild',
      value: 10,
      description: '5',
      color: '#FFC53D',
    },
    {
      name: 'Moderate',
      value: 15,
      description: '15',
      color: '#F87415',
    },
    {
      name: 'Severe',
      value: 20,
      description: '30',
      color: '#A8071A',
    },
  ],
};
